export interface SelectedMsisdnInterfaceState {
  phoneNumber: string;
}

export const initialSelectedMsisdnState: SelectedMsisdnInterfaceState = {
  phoneNumber: null
};
